import React, { Component } from 'react'
import './index.scss'

// elements
import Inline from '../../elements/inline'
import Label from '../../elements/label'
import Grid from '../../elements/grid'
import Panel from '../../elements/panel'
// import LabelWrapper from '../../elements/labelWrapper'
// components
import UserInfo from '../UserInfo'

// uitils
import { renderFullDate } from '../../../utils/time'
import { translation, getOrderNoteShareString } from '../../../utils/helpers'

class Notes extends Component {
  renderNote (item, key) {
    return <div key={key} className='display-note-item'>
      <Grid cols={[1, 'max-content']} align='start'>
        <div>
          <UserInfo user={item.UserInfo} />
          <Inline spacing={[0]}>
            {renderFullDate(item.NoteDate)}
          </Inline>
        </div>
      </Grid>
      <div>{translation(item.SourceDictionaryKey)}: {item.Note}</div>
      {item.ShareType > 0 && (<Label>
        {translation('17861')}
        {getOrderNoteShareString(item.ShareType)}
      </Label>)}
    </div>
  }

  render () {
    if (!this.props.notes) return null

    if (this.props.inline) {
      return (
        <Grid cols='1fr' nogap>
          {this.props.notes.map(this.renderNote)}
        </Grid>
      )
    }
    return (
      <Panel title={`${translation(14834)} (${this.props.notes.length})`}>
        <Grid cols='1fr' nogap>
          {this.props.notes.map(this.renderNote)}
        </Grid>
      </Panel>
    )
  }
}

Notes.defaultProps = {
  notes: [],
  inline: false // Determines if elements wrapped in a Panel
}

export default Notes



// WEBPACK FOOTER //
// ./src/app/shared/components/Notes/index.js